module.exports = __webpack_public_path__ + "static/media/star.118d363a.svg";